import { Typography } from '@mui/material';

import { AccessRequestClientModel } from '@apono/client-app-sdk';

export default function JustificationCell({ justification }: Pick<AccessRequestClientModel, 'justification'>) {
  return (
    <Typography variant="body2" noWrap>
      {justification}
    </Typography>
  );
}
